<template lang="html">
  <v-select
    v-model="selected"
    :items="items"
    :prepend-icon="prependIcon"
    :menu-props="{ maxHeight: '400' }"
    :label="label"
    :item-text="nameField"
    :item-value="itemIdField"
    multiple
    :hint="hint"
    :persistent-hint="persistentHint"
    :error-messages="errorMessages"
    @change="updateValue"
  />
</template>

<script>
import {rules} from '@/ft-vue-core'

export default {
  name: 'BoundPropertySelector',
  components: {},
  mixins: [rules],
  props: {
    icon: String,
    prependIcon: String,
    items: Array,
    propertyIdField: String,
    parentIdField: String,
    itemIdField: String,
    nameField: String,
    hint: String,
    label: String,
    parentId: Number,
    value: Array,
    errorMessages: Array,
    disabled: Boolean,
    persistentHint: Boolean,
  },
  data: function () {
    return {
      selected: []
    }
  },
  computed: {
    itemsMap () {
      const itemIdField = this.itemIdField
      return this.items.reduce((a, p) => {a[p[itemIdField]] = p; return a}, {})
    }
  },
  watch: {
    value: {
      deep: true,
      handler (val) {
        this.setSelected(val)
      },
    },
  },
  mounted () {
    this.setSelected()
  },
  methods: {
    setSelected (val) {
      val = val || this.value || []
      const propertyIdField = this.propertyIdField
      const itemIdField = this.itemIdField
      this.selected = val.reduce((a, v) => {
        const pid = v[propertyIdField]
        const item = this.itemsMap[pid]
        if (item) {
          a.push(item[itemIdField])
        }
        return a
      }, [])
    },
    updateValue () {
      const propertyIdField = this.propertyIdField
      const parentIdField = this.parentIdField
      const parentId = this.parentId
      const value = this.selected.reduce((a, pid) => {
        const v = {}
        v[parentIdField] = parentId
        v[propertyIdField] = pid
        a.push(v)
        return a
      }, [])
      this.$emit('input', value)
    }
  }
}
</script>
